import httpClient from '@/lib/httpClient.js'
import { useQuery, useQueryClient } from '@tanstack/react-query'

export default function useGetPeriodColumns({
  isAuthenticated = true,
  offset = null,
  numberOfPeriods = null,
  periodType = null,
} = {}) {
  const queryClient = useQueryClient()
  const fetchData = async () => {
    const response = await httpClient.get('team/cash-flow/periods', {
      params: {
        o: offset,
        c: numberOfPeriods,
        p: periodType,
      },
    })

    queryClient.setQueryDefaults(['latest-periods'], {
      gcTime: Infinity,
    })

    queryClient.setQueryData(['latest-periods'], response.data.data)

    // queryClient.invalidateQueries({
    //   queryKey: ['periods-cache'],
    // })

    return response.data.data
  }

  return useQuery({
    queryKey: ['periods', { offset, numberOfPeriods, periodType }],
    queryFn: fetchData,
    enabled: isAuthenticated,
    staleTime: Infinity,
  })
}
